/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {Injectable} from "@angular/core";
import {Selector, State} from "@ngxs/store";
import {TrecApiError, TrecError} from "@trec/api/errors";
import {ActivationCodeType} from "@trec/api/salute-helper";

/**
 * Common state contains useful data that is global to
 * the application. For example: TreC token, Logged user data, ...
 */
export interface ConfigurationStateModel {
  telemonitoraggio: boolean | null;
  televisita: boolean | null;
  chat: boolean | null;
  report: boolean | null;
  context: boolean | null;
  error: TrecError | TrecApiError | null | undefined;
  activationcode: ActivationCodeType | null;
  appointments: boolean | null;
  hd: boolean | null;
}

@State<ConfigurationStateModel>({
  name: "configuration",
  defaults: {
    telemonitoraggio: null,
    televisita: null,
    chat: null,
    appointments: null,
    report: null,
    context: null,
    error: null,
    hd: null,
    activationcode: ActivationCodeType.visible,
  },
})
@Injectable()
export class ConfigurationState {
  constructor() { }

  // Select status //////////////////////////////

  @Selector()
  static error(state: ConfigurationStateModel) {
    return state.error;
  }

  // Selectors ////////////////////////////////////////////////////////////////////////////////////

  @Selector()
  static fetchConfigurationApp(state: ConfigurationStateModel) {
    return {
      hd: state.hd,
      chat: state.chat,
      report: state.report,
      televisita: state.televisita,
      telemonitoraggio: state.telemonitoraggio,
      context: state.context,
      activationcode: state.activationcode,
      appointments: state.appointments,
    };
  }

  // Special Selectors ////////////////////////////////////////////////////////////////////////////
}
